export function isEmptyDateRangeResponse(column: any): boolean {
  return Array.isArray(column) &&
    column[0]?.column_name?.message === 'No se encuentra información para la selección actual.';
}

export function isEmptyDateRangeResponseObject(column: any): boolean {
  if (!column || typeof column !== 'object') {
    return false;
  }

  return Object.values(column).some(value => {
    // Verificar que value sea un objeto y tenga message
    if (value && typeof value === 'object' && 'message' in value) {
      return (value as { message: string }).message ===
        'No se encuentra información para la selección actual.';
    }
    return false;
  });
}
